import {
    Grid,
    TextField,
    FormHelperText,
    Select,
    MenuItem,
  } from "@mui/material";
import { useState } from "react";
import { MdCloudUpload, MdDelete } from 'react-icons/md';
import { AiFillFileImage } from 'react-icons/ai';
import './images.css';
import {Field} from 'formik';

const PersonalDetails = (props) => {
    const { formik } = props;
    const [image, setImage] = useState(null)
    const [fileName, setFileName] = useState("No selected file")

    const handleFileChange = (event) => {
        const file = event.currentTarget.files[0];
        if (file) {
            setFileName(file.name);
            setImage(URL.createObjectURL(file));
            formik.setFieldValue("memberImage", file);
        }
    };
    
    return(
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        name="firstname"
                        id="firstname"
                        label="First name"
                        variant="outlined"
                        type="text"
                        fullWidth
                        size="small"
                        value={formik.values.firstname}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.firstname && Boolean(formik.errors.firstname)}
                        helperText={formik.touched.firstname && formik.errors.firstname}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="middlename"
                        id="middlename"
                        label="Middlename"
                        variant="outlined"
                        size='small'
                        type="text"
                        fullWidth                
                        value={formik.values.middlename}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="lastname"
                        id="lastname"
                        label="Last name"
                        variant="outlined"
                        size="small"
                        type="text"
                        fullWidth
                        value={formik.values.lastname}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="otherName"
                        id="otherName"
                        label="Other name"
                        variant="outlined"
                        size="small"
                        type="text"
                        fullWidth
                        value={formik.values.otherName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="commonname"
                        id="commonname"
                        label="Common name"
                        variant="outlined"
                        size="small"
                        type="text"
                        fullWidth
                        value={formik.values.commonname}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="dob"
                        id="dob"
                        label="Date of Birth"
                        variant="outlined"
                        size="small"
                        type="date"
                        fullWidth
                        value={formik.values.dob}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12}>
                    <p>Gender</p>
                    <Select
                        // required
                        name="gender"
                        id="gender"
                        label="Gender"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={formik.values.gender}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.gender && Boolean(formik.errors.gender)}
                        helperText={formik.touched.gender && formik.errors.gender}
                    >
                       <MenuItem value="male">Male</MenuItem>
                        <MenuItem value="female">Female</MenuItem> 
                    </Select>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="ghCardNumber"
                        id="ghCardNumber"
                        label="Card Number(GH Card, Voters ID.. etc)"
                        variant="outlined"
                        size="small"
                        type="text"
                        fullWidth
                        value={formik.values.ghCardNumber}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12}>
                <div className="form">
                <input
                        name="memberImage"
                        id="memberImage"
                        type="file"
                        accept="image/*"
                        className="input-field"
                        onChange={handleFileChange}
                    />
                    <FormHelperText sx={{ color:'darkblue'}}>Member Photo Here</FormHelperText>

                    {image ? (
                    <img src={image} width={150} height={150} alt={fileName} />
                    ) : (
                    <>
                        <MdCloudUpload color="#1475cf" size={60} />
                        <p>Browse Files to upload Member Photo</p>
                    </>
                    )}

                    <section className="uploaded-row">
                    <AiFillFileImage color="#1475cf" />
                    <span className="upload-content">
                        {fileName} --
                        <MdDelete
                        onClick={() => {
                            setFileName("No selected File");
                            setImage(null);
                            formik.setFieldValue("ghCardImage", null);
                        }}
                        />
                    </span>
                    </section>
            </div>
                </Grid>
                {formik.errors.submit && (
                    <Grid item xs={12}>
                    <FormHelperText error>
                        {formik.errors.submit}
                    </FormHelperText>
                    </Grid>
                )}
            </Grid>
        </div>
    );
}

export default PersonalDetails;